module.exports = __webpack_public_path__ + "060b2168748ae0bc6bd75a654ff29c6a.svg";